import { RecordIcon } from './RecordIcon';

/**
 * author: Simran
 * id F84F1E59-868C-42CE-80EA-159588E83462
 * name record
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/record.svg
 * tags
 * - Home Automation 
 */
export const FiberManualRecordIcon = RecordIcon;
export default FiberManualRecordIcon